import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonsModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { CheckboxModule } from '../checkBox/checkbox.module';
import {
  AlertComponent,
  AxisNotificationComponent,
  AxisAlertHeadingComponent,
  AxisAlertHeadingRightComponent,
  AxisAlertBodyComponent
} from './alert.component';
import { AlertService } from './alert.service';
@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    CheckboxModule,
    IconModule
  ],
  declarations: [
    AlertComponent,
    AxisNotificationComponent,
    AxisAlertHeadingComponent,
    AxisAlertHeadingRightComponent,
    AxisAlertBodyComponent
  ],
  exports: [
    AlertComponent,
    AxisNotificationComponent,
    AxisAlertHeadingComponent,
    AxisAlertHeadingRightComponent,
    AxisAlertBodyComponent
  ],
  providers: [
    AlertService
  ]
})
export class AlertModule { }
